import React from 'react'

export default function SelectCampaigns() {
    return (

        <div className='select-campaigns-page container pt-45'>
            <header class="select-campaigns-header">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <a > All Campaigns</a>
                        </li>
                    </ol>
                </nav>
                <div className="page-title-heading">
                    <h1 className='title-heading'>Select a Campaign Type</h1>
                </div>
            </header>
            <div className="row pt-25">
                <div className='col-lg-4'>
                    <div className="marketing-card green">
                        <div className="header">
                            <span className="icon">
                                <i className='icon-eye'></i>
                            </span>
                            <div className="header-text"> ABANDONED BROWSE </div>
                        </div>

                        <div className="marketing-card-body">
                            <div className="header-text">Description</div>
                            <div className="body-text">
                                Prompt customers to purchase the items they left when browsing
                            </div>
                        </div>
                        <div className="marketing-card-footer">
                            <div className="header-text">Impact</div>
                            <div className="row">
                                <div className="col-md-3">
                                    <span className="footer-icon">
                                        <i className="icon-money"></i>
                                    </span>
                                </div>
                                <div className="col-md-9">
                                    <div className="body-text">
                                        Browse recovery emails convert at a rate 60% higher than promotional emails.
                                    </div>
                                </div>
                            </div>
                            <div className="row justify-content-center">
                                <a target="_blank" className="w-100" href="#">
                                    <button
                                        className="btn"
                                    >
                                        Select
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-lg-4'>
                    <div className="marketing-card purple">
                        <div className="header">
                            <span className="icon">
                                <i className='icon-cross-sell'></i>
                            </span>
                            <div className="header-text"> CROSS-SELL </div>
                        </div>

                        <div className="marketing-card-body">
                            <div className="header-text">Description</div>
                            <div className="body-text">
                                Prompt customers to purchase the items they left when browsing
                            </div>
                        </div>
                        <div className="marketing-card-footer">
                            <div className="header-text">Impact</div>
                            <div className="row">
                                <div className="col-md-3">
                                    <span className="footer-icon">
                                        <i className="icon-money"></i>
                                    </span>
                                </div>
                                <div className="col-md-9">
                                    <div className="body-text">
                                        Browse recovery emails convert at a rate 60% higher than promotional emails.
                                    </div>
                                </div>
                            </div>
                            <div className="row justify-content-center">
                                <a target="_blank" className="w-100" href="#">
                                    <button
                                        className="btn"
                                    >
                                        Select
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-lg-4'>
                    <div className="marketing-card sky-blue">
                        <div className="header">
                            <span className="icon">
                                <i className='icon-high-value-customer'></i>
                            </span>
                            <div className="header-text">High Value Customer </div>
                        </div>

                        <div className="marketing-card-body">
                            <div className="header-text">Description</div>
                            <div className="body-text">
                                Prompt customers to purchase the items they left when browsing
                            </div>
                        </div>
                        <div className="marketing-card-footer">
                            <div className="header-text">Impact</div>
                            <div className="row">
                                <div className="col-md-3">
                                    <span className="footer-icon">
                                        <i className="icon-money"></i>
                                    </span>
                                </div>
                                <div className="col-md-9">
                                    <div className="body-text">
                                        Browse recovery emails convert at a rate 60% higher than promotional emails.
                                    </div>
                                </div>
                            </div>
                            <div className="row justify-content-center">
                                <a target="_blank" className="w-100" href="#">
                                    <button
                                        className="btn"
                                    >
                                        Select
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}
